export default __webpack_public_path__ + "static/media/icon_vspacer.3f18f6e5.svg";